import ReactDOM from 'react-dom/client';
import App from './App';
import "./index.scss";
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import Store from './ReduxToolkit/Store';
import './i18n'
import { unstable_batchedUpdates } from 'react-dom';
import React from 'react';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Comentado temporalmente para ver errores en desarrollo
// unstable_batchedUpdates(() => {
//   console.error = () => { };
// });

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, { hasError: boolean; error: Error | null }> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    if (error.message.includes("ToastContainer")) {
      return;
    }
    // Mostrar error en consola para debugging
    console.error('Error capturado por ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.state.error) {
      // Mostrar mensaje de error en desarrollo
      if (process.env.NODE_ENV === 'development') {
        return (
          <div style={{ padding: '20px', color: 'red' }}>
            <h1>Error en la aplicación</h1>
            <p>{this.state.error.message}</p>
            <pre>{this.state.error.stack}</pre>
            <button onClick={() => window.location.reload()}>Recargar página</button>
          </div>
        );
      }
      // En producción, mostrar mensaje genérico
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Algo salió mal</h1>
          <p>Por favor, recarga la página.</p>
          <button onClick={() => window.location.reload()}>Recargar página</button>
        </div>
      );
    }

    return this.props.children;
  }
}

root.render(
  <Provider store={Store}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
